import React from 'react';
import { 
  HelpCircle, 
  Wallpaper, 
  Ruler, 
  Scissors, 
  Clock, 
  Droplet, 
  Brush, 
  ShoppingCart 
} from 'lucide-react';

const TipsSidebar = ({ glueTypes }) => {
  const tips = [
    {
      icon: Wallpaper,
      title: 'Выбор обоев',
      description: 'Для маленьких комнат выбирайте светлые обои с мелким рисунком, для больших – можно использовать крупный рисунок и темные оттенки.'
    },
    {
      icon: Ruler,
      title: 'Расчет раппорта',
      description: 'При наличии раппорта (повторяющегося узора) учитывайте дополнительный расход материала на совмещение рисунка.'
    },
    {
      icon: Scissors,
      title: 'Нарезка полос',
      description: 'Нарезайте полосы с запасом 5-10 см сверху и снизу для подгонки и выравнивания.'
    },
    {
      icon: Clock,
      title: 'Время на поклейку',
      description: 'На комнату площадью 18-20 м² в среднем уходит 1-2 дня работы, учитывайте это при планировании.'
    },
    {
      icon: Droplet,
      title: 'Клей для обоев',
      description: 'Выбирайте клей в соответствии с типом обоев: для тяжелых и флизелиновых нужен усиленный состав.'
    },
    {
      icon: Brush,
      title: 'Подготовка стен',
      description: 'Перед поклейкой обязательно выровняйте стены и загрунтуйте поверхность для лучшего сцепления.'
    },
    {
      icon: ShoppingCart,
      title: 'Покупка материалов',
      description: 'Приобретайте обои с одинаковым номером партии, чтобы избежать различий в оттенке.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Droplet className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Подбор клея для обоев
            </h4>
            <ul className="text-xs text-blue-600 dark:text-blue-400 mb-3 space-y-1.5">
              {glueTypes.map((type) => (
                <li key={type.id} className="flex items-start">
                  <span className="mr-1">•</span>
                  <span>
                    <strong>{type.name}</strong> - {type.description}
                  </span>
                </li>
              ))}
            </ul>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Строго соблюдайте пропорции при приготовлении клея и время выдержки, указанные на упаковке.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;